// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Order_loaderContainer__78qT7","controls":"Order_controls__hIVDH","controlItems":"Order_controlItems__Pw312","itemsCount":"Order_itemsCount__Kzcp1"};